import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { SCORING_LABELS, effectiveScoring, getSport } from "@/lib/sports";
import { Calculator, RotateCcw } from "lucide-react";

const inputClass =
  "bg-[#0E0F13] border-white/10 text-white placeholder:text-zinc-600 focus-visible:border-[#D4AF37] focus-visible:ring-1 focus-visible:ring-[#D4AF37] rounded-md";

/**
 * ScoringEditor — barème de points auto par sport (ex : V=3, N=1, D=0).
 * Rend null pour les sports sans barème (points 100% manuels).
 */
export default function ScoringEditor({ sport, scoring, onChange, onRecomputeAll, testIdPrefix = "scoring" }) {
  const base = getSport(sport).scoring;
  if (!base) return null;
  const eff = effectiveScoring(sport, scoring);
  const isCustom = scoring && Object.keys(scoring).length > 0;
  const setW = (k, v) => onChange({ ...eff, [k]: v === "" ? 0 : Number(v) });

  return (
    <div
      className="bg-[#0A0B0E] border border-white/5 rounded-md p-4 space-y-3"
      data-testid={`${testIdPrefix}-panel`}
    >
      <div className="flex items-center gap-2 text-overline !text-zinc-400">
        <Calculator className="w-3.5 h-3.5 text-[#D4AF37]" />
        Barème de points — calcul automatique
      </div>
      <div className="flex flex-wrap items-end gap-3">
        {Object.keys(base).map((k) => (
          <div key={k} className="space-y-1">
            <Label className="text-[10px] uppercase tracking-[0.18em] text-zinc-500">
              {SCORING_LABELS[k] || k}
            </Label>
            <Input
              type="number"
              className={`${inputClass} w-24`}
              value={eff[k] ?? 0}
              onChange={(e) => setW(k, e.target.value)}
              data-testid={`${testIdPrefix}-${k}`}
            />
          </div>
        ))}
        {isCustom && (
          <button
            type="button"
            onClick={() => onChange({})}
            className="h-10 px-3 text-[10px] uppercase tracking-[0.14em] text-zinc-500 hover:text-white"
            data-testid={`${testIdPrefix}-reset`}
          >
            Barème par défaut
          </button>
        )}
        {onRecomputeAll && (
          <button
            type="button"
            onClick={onRecomputeAll}
            className="h-10 inline-flex items-center gap-1.5 px-3 rounded-md border border-[#D4AF37]/40 text-[#D4AF37] hover:bg-[#D4AF37]/10 text-[10px] uppercase tracking-[0.14em] font-bold"
            data-testid={`${testIdPrefix}-recompute-all`}
          >
            <RotateCcw className="w-3 h-3" /> Recalculer tous les points
          </button>
        )}
      </div>
      <p className="text-zinc-600 font-body text-xs">
        Les points (PTS) se calculent automatiquement pendant la saisie. Si tu modifies
        directement la colonne PTS d'une ligne (pénalité, bonus, règlement particulier…),
        elle passe en mode manuel — clique « Auto » sur la ligne pour revenir au calcul.
      </p>
    </div>
  );
}
